import { faEdit, faMapMarked } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import Mispichoshelper from "../../../utils/Mispichoshelper";

const EditPostalCode = ({ order, visible, setVisible, runPostEdition }) => {

    const [loading, setLoading] = useState(false);
    const [postalCode, setPostalCode] = useState('');

    const confirmPostalCode = () => {
        Modal.confirm({
            title: 'Confirmar código postal',
            content: `¿Estás seguro de que deseas actualizar el código postal para la compra #${order?.compra_id}?`,
            onOk() {
                editPostalCode();
            }
        });
    }

    const editPostalCode = async () => {
        if (!!postalCode === false) {
            Modal.error({
                title: 'Código postal inválido',
                content: 'El código postal no puede estar vacío. Por favor, ingresa un código postal válido.',
            });
            return;
        }
        setLoading(true);
        const params = {
            order_id: order?.compra_id,
            postal_code: postalCode
        }
        const postalCodeEdition = await Mispichoshelper.postPostalCodeEdition(params);
        if (postalCodeEdition && postalCodeEdition.status) {
            Modal.success({
                title: 'Código postal actualizado',
                content: `El código postal para la compra #${order?.compra_id} ha sido actualizado correctamente.`,
                onOk() {
                    setLoading(false);
                    setVisible(false);
                    window.location.reload();
                }
            });
        } else {
            Modal.error({
                title: 'Error al actualizar el código postal',
                content: `Hubo un error al actualizar el código postal para la compra #${order?.compra_id}. Por favor, intenta nuevamente.`,
            });
            setLoading(false);
            setVisible(false);
        }
    }

    const handleCancelEdition = () => {
        setPostalCode('');
        setVisible(false);
    }

    return <Modal
        title={<><FontAwesomeIcon icon={faMapMarked} color="deepskyblue" /> Editar código postal del domicilio</>}
        visible={visible}
        onOk={confirmPostalCode}
        onCancel={handleCancelEdition}
        confirmLoading={loading}
        okText="Guardar código postal"
    >
        <p>La compra 🛍️<strong>#{order?.compra_id}</strong> se encuentra en la dirección <strong>{order?.compra_domicilio}</strong> pero el código postal es incorrecto o nulo.</p>
        <Divider />
        <p style={{ padding: "0px 0px 10px 0px" }}><FontAwesomeIcon icon={faEdit} /> Por favor, ingrese el nuevo código postal:</p>
        <Input disabled={loading} placeholder="Ingrese el código postal" style={{ fontSize: '17px', padding: '20px' }} onChange={e => setPostalCode(e.target.value)} value={postalCode} />
    </Modal>
}

export default EditPostalCode;